/**
 * foliage - Belaubungsfaktor für den Schattenwurf (#605)
 *
 * Einfaches Belaubungsfenster (beschlossen 2026-07-06, Kein-Erfinden-Grundsatz):
 * immergrüne Pflanzen werfen ganzjährig vollen Schatten; laubabwerfende von
 * Mai–Oktober voll, sonst nur reduzierten Ast-/Stammschatten. Kein artgenauer
 * Laubaustrieb — dafür fehlen belastbare Daten (Follow-up mit #541-Permapeople).
 *
 * Der Faktor gewichtet im Momentschatten die Opacity des Polygons und in der
 * Jahres-Aggregation (#606) die Beschattung der Zelle. Strukturen (Mauer,
 * Gebäude, …) sind kein Fall für dieses Modul — sie sind immer 1.0.
 */

export const FOLIAGE_FULL = 1.0;
export const FOLIAGE_BARE = 0.2;

// Belaubungsfenster: Mai–Oktober (0-indexierte Monate 4–9) voll belaubt.
const LEAF_ON_START_MONTH = 4; // Mai
const LEAF_ON_END_MONTH = 9; // Oktober

/**
 * Belaubungsfaktor einer Pflanze für einen Monat.
 *
 * @param {boolean} evergreen - true = immergrün
 * @param {number} month - Monat, 0-indexiert (0 = Januar … 11 = Dezember)
 * @returns {number} 1.0 (voll belaubt) oder 0.2 (kahl)
 */
export function foliageFactor(evergreen, month) {
  if (evergreen) return FOLIAGE_FULL;
  return month >= LEAF_ON_START_MONTH && month <= LEAF_ON_END_MONTH
    ? FOLIAGE_FULL
    : FOLIAGE_BARE;
}
